import React, { Component } from "react";
import SliderComponent from "./SliderComponent";
import MetaTagComp from "./MetaTagComp";

class Splash extends Component {
  render() {
    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <MetaTagComp section={"home"} />
        <SliderComponent menuitems={this.props.items} />
      </div>
    );
  }
}

export default Splash;
